import { toObject } from "../../core/utils";
import mapValues from "lodash/fp/mapValues";

class CountryPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    if (data.feature_flags) {
      data.feature_flags = mapValues(toObject, data.feature_flags);
    }
    return toObject(data);
  }
}

export default CountryPageTransform;



// WEBPACK FOOTER //
// ./src/pages/country/country.transforms.js